 <template>
    <v-container fluid>
        <v-card flat>
            <v-card-text>
                <v-row align="center" dense>
                    <v-spacer></v-spacer>
                    <v-col cols="2">
                        <v-btn color="success" @click="getItems()" :disabled="loading">Refrescar</v-btn>
                    </v-col>
                </v-row>
                <v-flex>
                    <v-card dense>
                    <v-toolbar dense :color="$store.state.UiColors.crudToolbarList">
                        <v-icon>list</v-icon>
                        <v-toolbar-title class="font-weight-light">Lista</v-toolbar-title>
                        <v-spacer></v-spacer>                      
                    </v-toolbar>
                    <v-data-table 
                            loading-text="Buscando registros"
                            dense
                            :headers="headers"
                            :items="records"
                            :rows-per-page="pagination.itemsPerPage"
                            :options.sync ="pagination"
                            v-model="selectedRows"
                            :loading="loading"  
                            class="elevation-1"
                            :footer-props="footer"
                            :show-select="records.length>0"
                            item-key="id"                    
                        >

                        <template v-slot:header.data-table-select="{ on, props }">
                            <v-checkbox @change="selectAllChanged" color="purple" v-bind="props" v-on="on"></v-checkbox>
                        </template>
                        
                        <template slot="no-data">
                                <v-alert :value="true" color="grey" icon="warning">
                                No se encontraron registros con los filtros ingresados
                                </v-alert>
                        </template>

                        <template v-slot:item="{ item,isSelected, select }">
                            <tr>
                                <td><v-simple-checkbox class="caption" color="green" :value="isSelected" @input="select($event)"></v-simple-checkbox></td>
                                <td><app-acciones-comunes :personaId="item.solicitanteId"  > </app-acciones-comunes></td>

                                <td class="text-xs-left caption">{{ item.origen }}</td>
                                <td class="text-xs-left caption">{{ item.producto }}</td>
                                <td class="text-xs-left caption">{{ item.grupoComercial }}</td>
                                <td class="text-xs-left caption">{{ item.cuil }}</td>
                                <td class="text-xs-left caption">{{ item.solicitante }}</td>
                                <td class="text-xs-left caption">{{ item.monto | currency}}</td>                                                                                
                                <td class="text-xs-left caption">{{ item.fechaIngreso | dateParse() | dateFormat('DD-MM-YYYY') }}</td>
                                <td class="text-xs-left caption"><v-chip small :color="item.empresaColor" label dark>{{item.empresaShort}}</v-chip></td>
                                <td>
                                    <!-- Para los casos con estado UC Confirmado-->
                                    <v-tooltip bottom v-if="item.estadoTransferenciaId == 2">
                                    <template v-slot:activator="{ on }">
                                        <v-icon small color="red" @click="quitarItem(item)" v-on="on">clear</v-icon>
                                    </template>
                                    Quitar caso de la lista de transferencias
                                    </v-tooltip>
                                </td>                        
                            </tr>
                            </template>
                        </v-data-table>
                    </v-card >
                </v-flex>
            </v-card-text>
                <v-card-actions>
                    <v-container fluid>
                        <v-layout>
                        <v-row>
                            <v-col v-if="selectedRows.length > 0">
                                <v-btn color="success" @click="quitarMarcaNoPagar()" :disabled="loading">
                                    Quitar Marca de No Pagar
                                </v-btn>
                            </v-col>
                            </v-row>
                        </v-layout>
                    </v-container>
                </v-card-actions>                     
        </v-card>
        <app-loading :loading="saving"></app-loading>
    </v-container>  
</template>

<script>

import { http } from '@/axios'

import {
  //mapState,
  mapGetters,
  mapMutations
} from 'vuex'


export default {

  data() {
    return {      
      saving: false,
      loading: false,      
      pagination: { // definición de paginación
        sortDesc:[true],
        sortBy:[''],
        page: 1,
        itemsPerPage: 5
      },
      footer:{        
        showFirstLastPage: true,
        itemsPerPageOptions:[5,10,20, 50],
        showCurrentPage: true
      },
      totalItems: 0, // va afuera de pagination 
      headers: [ // definición de columnas
        { text: 'Ver', value: 'accion', width:80, sortable:false },
        { text: 'Origen del Crédito', value: 'origen'},
        { text: 'Producto', value: 'producto'},
        { text: 'Grupo Comer.', value: 'grupoComercial'},
        { text: 'Cuil', value: 'cuil'},
        { text: 'Solicitante del Crédito', value: 'solicitante'},
        { text: 'Monto', value: 'monto', width: 130},
        { text: 'Fecha de Ingreso', value: 'fechaIngreso'},
        { text: 'Empresa', value: 'empresaNombre', width:100},
        { text: '', value: '', width:100, sortable:false},
      ],      
      records: [], // registros
      selectedRows: [],
    };
  },
  async created() {
      this.getItems();
  },  
  watch: {
        pagination : {
            handler(){
            if(this.primeraBusquedaRealizada)
                this.getItems(false);
            },
            deep: true
        },
    },
  computed: {    
    ...mapGetters(['getActionFromLink','user', 'checkCanAccess']),
    action: function(){
      return this.getActionFromLink(this.$route.path)
    },
  },
  methods: {
    ...mapMutations(["alertClear", "alertSuccess", "alertWarning", "alertError"]),
    selectAllChanged(toggle){
      this.selectedRows = []
      if(toggle){
        for (let index = 0; index < this.records.length; index++) {
          const element = this.records[index];
          
          this.selectedRows.push(element)
        }
      }
    },
    async getItems() {
        this.loading = true;
        try {
            var result = await http.get('creditos/list-creditos-marca-no-pagar');
            
            this.records = result.list;
            this.selectedRows = [];
            
            this.totalItems = result.totalCount
        } catch (error) {
            // Error
            this.alertError(error)
        }
        this.loading = false
    },
    async quitarMarcaNoPagar(){
      const msg = '¿Confirma que desea reinsertar los ' + this.selectedRows.length + ' Créditos seleccionados al circuito de pago?';
      
      if (confirm(msg)) {
        this.saving = true;
        
        try{
            var params = {};
            params.creditosId = this.selectedRows.map(x => x.id);
            params.nuevoSubEstadoId = 103; // Activa Pago Pendiente            
            await http.post('creditos/cambiarestadomasivo', JSON.stringify( {parametros:  params} ) );
            
            await this.alertSuccess('Se ha modificado el estado de los créditos.')
            this.selectedRows = [];
            this.getItems();
          }
          catch(error){
            this.alertError(error)
          }
          this.saving = false;
      }
    },
  }
}
</script>